module.exports = __webpack_public_path__ + "img/soil-sensors.7bd0e3a2.svg";